import Button from 'flarum/common/components/Button';
import Placeholder from 'flarum/common/components/Placeholder';
import { cropName } from '../../common/utils/cropNames.mjs';
import { salePricing } from '../utils/farmLabels.mjs';

export default {
  view(vnode) {
    const farm = vnode.attrs.farm || {};
    const busy = vnode.attrs.busy;
    const onSell = vnode.attrs.onSell;
    const inventory = (farm.inventory || []).filter((item) => Number(item.quantity) > 0);
    return (
      <aside className="YingtaoFarmSidebar" aria-labelledby="yingtao-warehouse-title">
        <h2 id="yingtao-warehouse-title">仓库</h2>
        {inventory.length ? inventory.map((item) => {
          const pricing = salePricing(farm.catalog, item);
          return (
            <div className="YingtaoInventoryRow" key={item.cropKey}>
              <div className="YingtaoInventoryRow-details">
                <strong>{cropName(item.cropKey)}</strong>
                <small>{pricing.quantity} 个 × {pricing.unitPrice} 金币/个</small>
              </div>
              <div className="YingtaoInventoryRow-actions">
                <span>预计 <strong>{pricing.totalPrice}</strong> 金币</span>
                <Button className="Button Button--link" disabled={busy || pricing.quantity === 0} onclick={() => onSell(item)}>
                  全部出售
                </Button>
              </div>
            </div>
          );
        }) : <Placeholder text="收获后会显示在这里。" />}
      </aside>
    );
  },
};
